import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ text = 'Loading…', fullPage = false }) => {
    if (fullPage) {
        return (
            <div className="loading-spinner-fullpage">
                <Spinner animation="border" variant="primary" />
                <span className="ms-2 text-muted">{text}</span>
            </div>
        );
    }

    return (
        <div className="d-flex align-items-center justify-content-center py-5">
            <Spinner animation="border" variant="primary" size="sm" />
            <span className="ms-2 text-muted">{text}</span>
        </div>
    );
};

export default LoadingSpinner;
